const languageSelectorStyle = {
  padding: 10,
  display: "flex",
  alignItems: "center",
};

const LanguageSwitcherStyle = (theme) => ({
  languageSelectorContainer: {
    padding: 10,
  },
  languageSelector: {
    ...languageSelectorStyle,
  },
  centeredLanguageSelector: {
    ...languageSelectorStyle,
    justifyContent: "center",
  },
  selectedLang: {
    position: "absolute",
    fontSize: 11,
    top: 0,
  },
});

export default LanguageSwitcherStyle;
